"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSIDERATIONS = void 0;
/* eslint-disable camelcase */
var lodash_1 = __importDefault(require("lodash"));
var Translation_1 = require("../Translation");
var AbstractRisk_1 = require("../risk/AbstractRisk");
var AbstractControl_1 = __importStar(require("./AbstractControl"));
var DesignReportColumn_1 = require("./DesignReportColumn");
var CONTROL_TYPES = [
    { key: 'id', required: true },
    { key: 'name', required: true },
    { key: 'goal', required: true },
    { key: 'narrative', required: true },
    { key: 'keyControl', radio: AbstractControl_1.YesNo },
    { key: 'Non_rational' },
    { key: 'period', radio: AbstractControl_1.Period },
    { key: 'preventDetective', radio: AbstractControl_1.PreventDetective },
    { key: 'autoManual', radio: lodash_1.default.omit(AbstractControl_1.AutoManual, 'ITAC') },
    { title: '규정 및 자원' },
    { key: 'policy' },
    { key: 'ITDependencySystem' },
    { title: 'MRC' },
    { key: 'MRC_YN', radio: AbstractControl_1.YesNo },
    { key: 'euc_code' },
    { key: 'euc_name' },
    { key: 'ITD_code' },
    { key: 'ITD_name' },
    { title: '통제 조직' },
    { key: 'department_description' },
    { key: 'team_name' },
    { key: 'teamLeader' },
    { key: 'teamMember' },
    { key: 'incharge', isStaff: true },
    { key: 'owner', isStaff: true },
    { title: '기타 통제 속성' },
    { key: 'control_category' },
    { key: 'fraud_yn', radio: AbstractControl_1.YesNo },
    { key: 'residualRiskLevel', radio: AbstractRisk_1.RiskLevel },
    { key: 'accountCode' },
    { key: 'accountName' },
    { key: 'reportFootnotes' },
    {
        key: 'auto_application',
        prefix: 'auto_application',
        checks: ['interface', 'calculation', 'autocontrol', 'restricted', 'SGI']
    },
    {
        key: 'assertion',
        prefix: 'assertion',
        checks: ['EO', 'RO', 'C', 'Accuracy', 'Measurement', 'PD', 'Cutoff']
    },
    { title: '통제 운영 속성' },
    { key: 'TOC_Procedure' },
    { key: 'TOC_Evidence' },
    { key: 'TOC_Population' },
    { key: 'TOC_Completeness' },
    { key: 'TOC_PopulationCount' },
    { key: 'TOC_TestProperties' },
    {
        key: 'TOC_TestMethod',
        prefix: 'TOC_TestMethod',
        checks: ['InquiryInspection', 'Examination', 'Observation', 'Reperformance']
    }
];
exports.CONSIDERATIONS = [
    {
        title: '통제 목적의 적절성 및 위험평가에서 인식된 위험/경영진의 주장과의 연관성',
        content: '통제목적(파악된 Risk & 경영진의 주장)에 통제활동이 부합하는가? (실제 Risk를 감소시키는가?)'
    },
    {
        title: '통제활동이 수행되는 기간, 빈도 및 일관성',
        content: '통제가 적용된 기간은 전체기간에 적용되었는가? (통제가 설계되어 수행된 기간은 충분한지)\n' +
            '통제 수행 빈도는 적정한가? (통제 수행 빈도가 위험을 적시에 예방하거나 적발할 수 있는지)\n' +
            '통제가 수행되는 빈도는 통제기간 동안 일관되게 적용되었는가?'
    },
    {
        title: '통제 수행 수준 및 예측가능성',
        content: '통제활동 수행의 세부항목/수준 혹은 예측기준 설정 방안은 충분한가?'
    },
    {
        title: '통제에 사용되는 정보의 신뢰성 확보',
        content: '통제수행에 필요한 정보의 신뢰성 확보 방안은 적절히 설계되었는가?'
    },
    {
        title: '예외사항 발생시 대응',
        content: '통제 수행 중에 발생하는 예외사항에 대한 추가 절차는 충분한가?'
    }
];
// NOTE: 수정 시 TPCReport.ts 의 대응되는 곳도 수정
function getDesignControlTypes() {
    return [
        [
            { value: (0, Translation_1.getKoName)('control', 'keyControl'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.keyControl', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'autoManual'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.autoManual', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'preventDetective'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.preventDetective', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'period'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.period', span: 3 }
        ],
        [
            { value: (0, Translation_1.getKoName)('risk', 'inherentRiskLevel'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.risk.inherentRiskLevel', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'residualRiskLevel'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.residualRiskLevel', span: 3 }
        ]
    ];
}
function getTOCColumns(isEditing) {
    return [
        [{ value: '통제평가절차', span: 24, style: DesignReportColumn_1.greyTitleStyle }],
        [
            { value: (0, Translation_1.getKoName)('control', 'TOC_TestControlElement'), span: 3, style: DesignReportColumn_1.blueStyle },
            {
                key: 'TOC_TestMethodChildren',
                span: 21,
                children: (0, lodash_1.default)([
                    'TOC_TestMethod_InquiryInspection',
                    'TOC_TestMethod_Observation',
                    'TOC_TestMethod_Examination',
                    'TOC_TestMethod_Reperformance'
                ])
                    .map(function (key) { return [
                    { value: (0, Translation_1.getKoName)('control', key), span: 4, style: DesignReportColumn_1.greenStyle },
                    { key: "content.control.".concat(key), span: 8 }
                ]; })
                    .flatten()
                    .chunk(4)
                    .value()
            }
        ],
        [
            { value: (0, Translation_1.getKoName)('control', 'TOC_ProcedureContent'), span: 3, style: DesignReportColumn_1.blueStyle },
            isEditing
                ? { key: 'procedureContent', editable: true, type: 'TextArea', span: 21 }
                : { key: 'content.data.procedureContent', span: 21, style: { whiteSpace: 'pre-line' } }
        ]
    ];
}
var TPCControl = /** @class */ (function (_super) {
    __extends(TPCControl, _super);
    function TPCControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.goal = '';
        _this.Non_rational = '';
        _this.autoManual = AbstractControl_1.AutoManual.auto;
        _this.policy = '';
        _this.ITDependencySystem = '';
        _this.MRC_YN = AbstractControl_1.YesNo.no;
        _this.euc_code = '';
        _this.euc_name = '';
        _this.ITD_code = '';
        _this.ITD_name = '';
        _this.department_description = '';
        _this.team_name = '';
        _this.teamLeader = '';
        _this.teamMember = '';
        _this.control_category = '';
        _this.fraud_yn = AbstractControl_1.YesNo.no;
        _this.accountCode = '';
        _this.accountName = '';
        _this.reportFootnotes = '';
        _this.auto_application_interface = AbstractControl_1.YesNo.no;
        _this.auto_application_calculation = AbstractControl_1.YesNo.no;
        _this.auto_application_autocontrol = AbstractControl_1.YesNo.no;
        _this.auto_application_restricted = AbstractControl_1.YesNo.no;
        _this.auto_application_SGI = AbstractControl_1.YesNo.no;
        _this.assertion_EO = AbstractControl_1.YesNo.no;
        _this.assertion_RO = AbstractControl_1.YesNo.no;
        _this.assertion_C = AbstractControl_1.YesNo.no;
        _this.assertion_Accuracy = AbstractControl_1.YesNo.no;
        _this.assertion_Measurement = AbstractControl_1.YesNo.no;
        _this.assertion_PD = AbstractControl_1.YesNo.no;
        _this.assertion_Cutoff = AbstractControl_1.YesNo.no;
        _this.TOC_Procedure = '';
        _this.TOC_Evidence = '';
        _this.TOC_Population = '';
        _this.TOC_Completeness = '';
        _this.TOC_PopulationCount = '';
        _this.TOC_TestProperties = '';
        _this.TOC_TestMethod_InquiryInspection = AbstractControl_1.YesNo.no;
        _this.TOC_TestMethod_Observation = AbstractControl_1.YesNo.no;
        _this.TOC_TestMethod_Examination = AbstractControl_1.YesNo.no;
        _this.TOC_TestMethod_Reperformance = AbstractControl_1.YesNo.no;
        return _this;
    }
    TPCControl.getKeysForExporting = function () {
        return _super.getKeysForExporting.call(this, CONTROL_TYPES);
    };
    TPCControl.from = function (data) {
        // TODO(sangmuk): Need to check proper variable.
        var control = new TPCControl();
        Object.assign(control, data);
        return control;
    };
    TPCControl.prepareEditingControls = function (control) {
        if (!(control instanceof TPCControl)) {
            throw new Error("Invalid control class ".concat(control));
        }
        return _super.prepareEditingControlsInner.call(this, CONTROL_TYPES, control);
    };
    TPCControl.getControlEditItems = function () {
        return _super.getControlEditItems.call(this, CONTROL_TYPES);
    };
    TPCControl.convertFormToControl = function (formValues, selectedStaff) {
        var control = new TPCControl();
        control.department = (selectedStaff === null || selectedStaff === void 0 ? void 0 : selectedStaff.departmentName) || '';
        return _super.convertFormToControlInner.call(this, CONTROL_TYPES, formValues, control);
    };
    TPCControl.prototype.updateForOperationTemplate = function (newControl) {
        _super.prototype.updateForOperationTemplate.call(this, newControl);
        if (!(newControl instanceof TPCControl)) {
            throw new Error('Different control types.');
        }
        this.goal = newControl.goal; // OE
        this.TOC_Population = newControl.TOC_Population; // OE
        this.TOC_TestProperties = newControl.TOC_TestProperties; // OE
        this.TOC_TestMethod_InquiryInspection = newControl.TOC_TestMethod_InquiryInspection; // DE
        this.TOC_TestMethod_Observation = newControl.TOC_TestMethod_Observation; // DE
        this.TOC_TestMethod_Reperformance = newControl.TOC_TestMethod_Reperformance; // DE
        this.autoManual = newControl.autoManual; // OE, DE
        this.preventDetective = newControl.preventDetective; // DE
    };
    TPCControl.prototype.getControlViewItems = function (staffs) {
        return _super.prototype.getControlViewItemsInner.call(this, CONTROL_TYPES, staffs);
    };
    TPCControl.getDesignDefect = function () {
        var _a = _super.getDesignDefectInner.call(this, CONTROL_TYPES), infoData = _a.infoData, methodData = _a.methodData;
        infoData.push({ value: '관련 위험' });
        infoData.push({ type: 'risk', key: 'name' });
        infoData.push({ type: 'risk', key: 'inherentRiskLevel', radio: AbstractRisk_1.RiskLevel });
        return {
            infoData: infoData,
            methodData: methodData
        };
    };
    TPCControl.getDesignDefectSummary = function () {
        var summaries = _super.getDesignDefectSummaryInner.call(this, CONTROL_TYPES);
        if (!('관련 위험' in summaries)) {
            throw new Error('No risk in defect summary.');
        }
        summaries['관련 위험'] = [
            { key: 'risk', subKey: 'name' },
            { key: 'risk', subKey: 'inherentRiskLevel' }
        ];
        return summaries;
    };
    TPCControl.getDesignColumns = function (staffs, isEditing) {
        return _super.getDesignColumnsInner.call(this, staffs, isEditing, true, exports.CONSIDERATIONS, getDesignControlTypes(), getTOCColumns(isEditing));
    };
    TPCControl.getEditableDesignColumns = function () {
        return _super.getEditableDesignColumnsInner.call(this, exports.CONSIDERATIONS, getTOCColumns(true));
    };
    return TPCControl;
}(AbstractControl_1.default));
exports.default = TPCControl;
//# sourceMappingURL=TPCControl.js.map